import { z } from "zod";

// Audit-fact event for an admin changing a user's system role (and the session
// invalidation that follows). Subject is the affected user.
export const systemRoleChanged = z.object({
  type: z.literal("SystemRoleChanged"),
  userPermissionId: z.string().min(1),
  systemRole: z.string(),
  preservedSessionId: z.string().nullable().optional(),
  sessionsInvalidated: z.boolean().default(true),
});

// Audit-fact event for an admin triggering a password reset email on behalf of a user.
export const passwordResetRequested = z.object({
  type: z.literal("PasswordResetRequested"),
  targetUserId: z.string().min(1),
});

export const accessEvents = [
  systemRoleChanged,
  passwordResetRequested,
] as const;
